import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const NodeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M5 4a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H5ZM2 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7 10c.6 0 1 .4 1 1v4a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H9a3 3 0 0 1-3-3v-4c0-.6.4-1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M15 14a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4Zm-3 1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default NodeIcon;
